import { Injectable } from '@angular/core';
import { PhotoOptionPickerComponent } from '@app/shared/components/photo-option-picker/photo-option-picker.component';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { ModalController } from '@ionic/angular';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { ToastSandbox } from '../sandboxes/toast.sandbox';
import { ImageSource } from '../types/common/photo.types';

const PHOTO_PICKER_ID = 'photo-picker';

@Injectable({ providedIn: 'root' })
export class PhotoService {
  constructor(
    private toastSandbox: ToastSandbox,
    private modalController: ModalController,
  ) {
    defineCustomElements(window);
  }

  /**
   * @deprecated use native file upload instead
   */
  async openPhotoOptionPicker(): Promise<ImageSource> {
    if ((await this.modalController.getTop())?.id === PHOTO_PICKER_ID) {
      return null;
    }
    const modal = await this.modalController.create({
      component: PhotoOptionPickerComponent,
      id: PHOTO_PICKER_ID,
      componentProps: {
        close: (source: ImageSource) => this.modalController.dismiss({ selectedOption: source }),
      },
      cssClass: ['auto-height-modal'],
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      handle: false,
    });
    await modal.present();
    const data = (await modal.onDidDismiss())?.data?.selectedOption;
    return data ?? null;
  }

  /**
   * @deprecated use native file upload instead
   */
  async getPhoto(source: ImageSource): Promise<string> {
    if (!source) {
      return null;
    }
    try {
      const photo = await Camera.getPhoto({
        quality: 100,
        resultType: CameraResultType.Base64,
        source: source as unknown as CameraSource,
      });
      return `data:image/${photo.format};base64,` + photo.base64String;
    } catch (e) {
      if (e.message === 'User cancelled photos app' || e.message === 'No image picked') {
        return null;
      }
      this.toastSandbox.showErrorToast({key: 'error.file-permission'});
      return null;
    }
  }
}
